/** Modelos e fichas de demonstração. Espelham a semente `0012`. */

import type { FichaPreenchida, ModeloDeFicha } from './tipos';

export const MODELOS: ModeloDeFicha[] = [
    {
        id: 'mod-anamnese', nome: 'Anamnese', versao: 1, campos: [
            { uid: 'b1', tipo: 'texto-longo', rotulo: 'Queixa principal', obrigatorio: true },
            { uid: 'b2', tipo: 'texto-longo', rotulo: 'Tratamentos anteriores' },
            { uid: 'b3', tipo: 'selecao-unica', rotulo: 'Gestante?', opcoes: ['Sim', 'Não', 'Não sei'] },
            { uid: 'b4', tipo: 'selecao-unica', rotulo: 'Tabagista?', opcoes: ['Sim', 'Não', 'Ex-tabagista'] },
            { uid: 'b5', tipo: 'selecao-unica', rotulo: 'Possui diabetes?', opcoes: ['Sim', 'Não', 'Não sei'] },
            { uid: 'b6', tipo: 'selecao-unica', rotulo: 'Possui hipertensão?', opcoes: ['Sim', 'Não', 'Não sei'] },
            { uid: 'b7', tipo: 'selecao-unica', rotulo: 'Utiliza medicamentos contínuos?', opcoes: ['Sim', 'Não'] },
            { uid: 'b8', tipo: 'selecao-multipla', rotulo: 'Patologias cutâneas', opcoes: ['Acne', 'Rosácea', 'Melasma', 'Dermatite'] },
            { uid: 'b9', tipo: 'texto-longo', rotulo: 'Alergias', obrigatorio: true },
            { uid: 'b10', tipo: 'texto-longo', rotulo: 'Observações' },
        ],
    },
    {
        id: 'mod-plano', nome: 'Plano de tratamento', versao: 1, campos: [
            { uid: 'b1', tipo: 'texto-longo', rotulo: 'Plano de tratamento', obrigatorio: true },
            { uid: 'b2', tipo: 'texto-longo', rotulo: 'Exames laboratoriais' },
            { uid: 'b3', tipo: 'texto-longo', rotulo: 'Prescrição' },
            { uid: 'b4', tipo: 'texto-longo', rotulo: 'Cuidados e home care' },
            { uid: 'b5', tipo: 'data', rotulo: 'Retorno previsto' },
        ],
    },
    {
        id: 'mod-evolucao', nome: 'Evolução', versao: 1, campos: [
            { uid: 'b1', tipo: 'data', rotulo: 'Data da sessão', obrigatorio: true },
            { uid: 'b2', tipo: 'numero', rotulo: 'Sessão número' },
            { uid: 'b3', tipo: 'texto', rotulo: 'Procedimento realizado', obrigatorio: true },
            { uid: 'b4', tipo: 'texto-longo', rotulo: 'Intercorrências' },
            { uid: 'b5', tipo: 'selecao-unica', rotulo: 'Resposta ao tratamento', opcoes: ['Ótima', 'Boa', 'Regular', 'Sem resposta'] },
            { uid: 'b6', tipo: 'texto-longo', rotulo: 'Conduta' },
        ],
    },
];

export const FICHAS: FichaPreenchida[] = [
    {
        id: 'fic-1', atendimentoId: 'at-ag-3', contatoId: 'p-bruno', modeloId: 'mod-anamnese', nome: 'Anamnese',
        respostas: {
            b1: 'Retorno de rotina. Sem queixas novas.',
            b3: 'Não', b4: 'Não', b5: 'Não',
            b9: 'Sensibilidade a ácido glicólico.',
            b10: 'Paciente relata boa adesão ao home care.',
        },
        preenchidaPor: 'Paulo Menezes', criadoEm: '2026-09-08T08:20:00-03:00', atualizadoEm: '2026-09-08T08:20:00-03:00',
    },
    {
        id: 'fic-2', atendimentoId: 'at-ag-3', contatoId: 'p-bruno', modeloId: 'mod-evolucao', nome: 'Evolução',
        respostas: { b1: '2026-09-08', b2: 3, b3: 'Retorno pós-limpeza de pele', b5: 'Boa', b6: 'Manter protocolo. Retorno em 30 dias.' },
        preenchidaPor: 'Paulo Menezes', criadoEm: '2026-09-08T08:28:00-03:00', atualizadoEm: '2026-09-08T08:28:00-03:00',
    },
];

/* Espelha o backfill da migração `0013`: toda ficha já gravada guarda a cópia
   do modelo com que foi preenchida. Sem isto o adaptador de demonstração leria
   pelo modelo vivo, e o teste passaria onde o servidor falharia. */
for (const ficha of FICHAS) {
    const modelo = MODELOS.find((m) => m.id === ficha.modeloId);
    if (!modelo) continue;
    ficha.definicaoUsada = modelo.campos.map((c) => ({ ...c }));
    ficha.versaoDoModelo = modelo.versao;
}
